import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import CanceledOrdersList from './canceledOrdersTable';
import Header from './header';
import Detail from './detail';
import './orders.scss';

const {
  restoreAccessoriesOrdersPage,
  fetchOrderAndTasksStatus,
  navigateTo,
} = Actions;

const PANES_INDICES = {
  'CREATE_ORDERS': 0,
  'CANCELED_ORDERS': 1,
};

const Index = ({type}) => {
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [selectedFilters, setSelectedFilters] = useState({
    'date': '',
    'dateEnd': '',
    'chassis': '',
    'status': '',
    'order': '',
    'invoiceType': 'N',
  });
  const permissions = useSelector((state) => state.session.permissions);
  const accessoriesOrders = useSelector((state) => state.accessoriesOrders);
  const dispatch = useDispatch();
  const isCreationTab = activeTabIndex === PANES_INDICES.CREATE_ORDERS ? true : false;

  useEffect(() => {
    const validateResources = type === 'accessories' ? resources.AccessoriesOrders : resources.PDSOrders;
    if (!hasAccessPermission(permissions, validateResources, scopes.Create)) {
      dispatch(navigateTo(paths.AccessDenied));
    }
    dispatch(restoreAccessoriesOrdersPage());
    dispatch(fetchOrderAndTasksStatus({'type': 'order'}));
  }, [dispatch]);

  useEffect(() => {
    dispatch(restoreAccessoriesOrdersPage());
  }, [type]);


  const onChangeTab = (activeIndex) => {
    setActiveTabIndex(activeIndex);
  };

  const setSelectedFiltersState = (date, dateEnd, chassis, status, order, invoiceType) => {
    setSelectedFilters({
      'date': date,
      'dateEnd': dateEnd,
      'chassis': chassis,
      'status': status === 'ALL' ? '' : status,
      'order': order,
      'invoiceType': invoiceType,
    });
  };

  const getPanesContent = () => {
    const panes = {
      [PANES_INDICES.CREATE_ORDERS]: <Detail type={type} accessoriesOrders={accessoriesOrders}
        filtersState={selectedFilters} />,
      [PANES_INDICES.CANCELED_ORDERS]: <CanceledOrdersList type={type} accessoriesOrders={accessoriesOrders} />,
    };
    return panes[activeTabIndex];
  };

  return (
    <div className='accessories-orders'>
      <Header
        type={type}
        activeTabIndex={activeTabIndex}
        isCreationTab={isCreationTab}
        changeTab={onChangeTab}
        accessoriesOrders={accessoriesOrders}
        changeSelectedFiltersState={setSelectedFiltersState.bind(this)}
      />
      {getPanesContent()}
    </div>
  );
};

export default Index;
